module.exports = __webpack_public_path__ + "static/media/police_car.2454993f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/police_car.svg
// module id = 90
// module chunks = 0